module.exports = __webpack_public_path__ + "img/pattern2.ffdc5a0.svg";